import { createFileRoute } from '@tanstack/react-router';
import { AssessmentOverviewEditPage } from '@/pages/assessment/ui/AssessmentOverviewEditPage';

export const Route = createFileRoute('/_protected/assessment/$assessmentId/overview/edit')({
  component: AssessmentOverviewEditPage,
});
